import React, { useContext, useState } from "react";
import { Box, Grid } from "@mui/material";
import Sensors2 from "./SensorsMob";
import { useTranslation } from "react-i18next";
import { Context } from "../LocalWrapper";
import { Tooltip } from "react-tooltip";
import "./SensorsFullStyle.css";

import carSensorsImg from "../../imgs/sensors/carSensorsImg.jpg";
import cutEngSen from "../../imgs/sensors/cutEngImg.jpg";
import doorSen from "../../imgs/sensors/doorSensImg.jpg";
import seatBeltSen from "../../imgs/sensors/seatBeltSensImg.jpg";
import iBtnSen from "../../imgs/sensors/iBtnImg.jpg";
import panicSen from "../../imgs/sensors/panicImg.jpg";
import tempSen from "../../imgs/sensors/tempImg.jpg";

const sensorsImages = {
  cutEngSen: cutEngSen,
  doorSen: doorSen,
  seatBeltSen: seatBeltSen,
  iBtnSen: iBtnSen,
  panicSen: panicSen,
  tempSen: tempSen,
};

const SensorsFull = () => {
  const context = useContext(Context);
  const { t } = useTranslation();
  const sensorsDataTrns = t("sensorsData", { returnObjects: true });

  // State to track the selected sensor for the central image
  const [selectedSensor, setSelectedSensor] = useState("");

  const handleCardClick = (sensor) => {
    setSelectedSensor(sensor);
  };

  const angleOffset = 0; // Offset to avoid y-axis positions

  return (
    <Box className="sensors-container">
      {/* header */}
      <Box
        sx={{
          margin: "0px",
          paddingBottom: "50px",
          display: { xs: "none", sm: "none", md: "flex", lg: "flex" },
        }}
      >
        <h1 className="sensors-full-header oz-header">
          {t("sen_header1")} {"  "}
          {context.dir === "ltr" && (
            <span style={{ color: "var(--primary)" }}> & </span>
          )}
          {t("sen_header2")}
        </h1>
      </Box>
      {/* runs on desktop */}
      <Box sx={{ display: { xs: "none", sm: "none", md: "flex", lg: "flex" } }}>
        <div className="circle-container">
          {/* Center Circular Card */}
          <div className="center-card">
            <img
              src={sensorsImages[selectedSensor?.imgSrc] || carSensorsImg}
              alt={selectedSensor.name}
              className="center-image"
            />
            {/* <h3>{selectedSensor.name}</h3>
            <p>{selectedSensor.det1}</p> */}
          </div>

          {/* Cards Around the Circle */}
          {Object.entries(sensorsDataTrns).map(([key, sensor], index) => {
            const angle =
              angleOffset +
              (index * (360 - 2 * angleOffset)) /
                Object.entries(sensorsDataTrns).length;
            const x = Math.cos((angle * Math.PI) / 180) * 330; // Radius for positioning
            const y = Math.sin((angle * Math.PI) / 180) * 300;

            return (
              <div
                key={key}
                className="circle-card"
                style={{
                  transform: `translate(${x}px, ${y}px)`,
                }}
                onClick={() => handleCardClick(sensor)}
                onMouseOver={() => handleCardClick(sensor)}
                onMouseOut={() => handleCardClick("")}
                data-tooltip-id="sensors-tb"
                data-tooltip-content={sensor?.det1}
              >
                <div className="card-content" data-tooltip-id="my-tooltip-1">
                  <img
                    src={sensorsImages[key]}
                    alt={sensor?.name}
                    className="card-image"
                  />
                  <div className="card-details">
                    <h4 className="card-details oz-paragraph">
                      {sensor?.name}
                    </h4>
                    {/* <p>{sensor?.det1}</p> */}
                  </div>
                </div>
                <Tooltip
                  style={{
                    backgroundColor: "#e67e22",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                  id="sensors-tb"
                  place="top"
                />
              </div>
            );
          })}
        </div>
      </Box>
      {/* runs on phone */}
      <Box sx={{ display: { xs: "flex", sm: "flex", md: "none", lg: "none" } }}>
        <Sensors2 />
      </Box>
    </Box>
  );
};

export default SensorsFull;
